import React, { useState } from "react";
import liveChat from "../live-chat.png";
import axios from "axios";
import { Link } from "react-router-dom";
import { toast } from "react-hot-toast";

function Login({ username, setUsername, joinChat, password, setPassword }) {
  const [email, setEmail] = useState("");
  const handleSubmit = async () => {
    try {
      const response = await axios.post("https://pingify-47gx.onrender.com/api/v1/auth/login", { email, password });
      const apiUsername = response?.data?.username || response?.data?.user?.username;
      if (apiUsername) {
        setUsername(apiUsername);
        toast.success("Logged in successfully");
        try { localStorage.setItem("pingify_username", apiUsername); } catch { }
        joinChat(apiUsername);
      } else {
        // fallback: use email prefix or local username field if provided
        const derived = username || (email ? email.split("@")[0] : "");
        setUsername(derived);
        toast.success("Logged in with derived username");
        try { localStorage.setItem("pingify_username", derived); } catch { }
        joinChat(derived);
      }
    } catch (err) {
      console.log("Error in Login", err);
      const msg = err?.response?.data?.message || "Login failed. Check your credentials.";
      toast.error(msg);
    }
  }
  return (
    <div className="min-h-screen flex items-center justify-center bg-black p-6 relative">
      <div className="bg-gray-900 p-8 rounded-xl shadow-lg w-full max-w-md text-center text-white">
        <img src={liveChat} alt="Live Chat" className="mx-auto w-20 h-20 mb-6" />
        <h1 className="text-3xl font-bold mb-2">Welcome to Pingify</h1>
        <p className="mb-6 text-gray-400">Join the conversation — choose a username</p>
        <input
          className="w-full mb-4 px-4 py-2 rounded-md bg-black border border-gray-700 text-white focus:outline-none focus:ring-2 focus:ring-white"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          className="w-full mb-4 px-4 py-2 rounded-md bg-black border border-gray-700 text-white focus:outline-none focus:ring-2 focus:ring-white"
          placeholder="Enter your password"
          value={password}
          type="password"
          onChange={(e) => setPassword(e.target.value)}
        />
        <button
          className="w-full bg-white text-black py-2 rounded-md font-semibold hover:bg-gray-300 transition"
          onClick={handleSubmit}
        >
          Join Chat
        </button>
        <div className="mt-4 text-sm text-gray-400">
          New here? <Link to="/signup" className="text-white underline">Create an account</Link>
        </div>
      </div>
    </div>
  );
}

export default Login;


